import { Shield } from "lucide-react";
import { Link } from "react-router-dom";

const cols = [
  {
    heading: "Product",
    links: [
      { label: "Pricing", to: "/pricing" },
      { label: "Features", to: "/#features" },
      { label: "How it works", to: "/#how-it-works" },
      { label: "Get the Add-in", href: "https://marketplace.microsoft.com/en-us/product/WA200010021?tab=Overview" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Support & FAQ", to: "/support" },
      { label: "Contact us", to: "/support#contact" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "Refund Policy", to: "/refund-policy" },
      { label: "Impressum", to: "/impressum" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="bg-surface-1 border-t border-border pt-16 pb-10">
      <div className="container px-4">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src="/assets/icon-32.png" alt="Email2Contact" className="w-7 h-7" />
              <span className="text-base font-display font-bold tracking-tight">Email2Contact</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-sm">
              An Outlook add-in that turns email signatures into structured contacts. Privacy-first,
              EU-hosted, AppSource-ready.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-card border border-border text-xs font-mono text-muted-foreground">
              <Shield className="w-3 h-3" />
              EU PRIVACY · GDPR
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.heading}>
              <h4 className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground mb-4">
                {col.heading}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) =>
                  "href" in link ? (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-foreground/80 hover:text-primary transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.to!}
                        className="text-sm text-foreground/80 hover:text-primary transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-6 border-t border-border flex flex-col md:flex-row gap-3 md:gap-6 items-start md:items-center justify-between text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Email2Contact. All rights reserved.</p>
          <p className="font-mono uppercase tracking-widest">Built in the EU</p>
        </div>
      </div>
    </footer>
  );
};
